<template>
    <div class="category-dialog">
        <el-dialog title="分类管理" :visible.sync="dialogVisible" width="552px" @close="resetEditing" :modal="true"
            scrollable="body" :append-to-body="true">
            <!-- 添加过渡动画包装器 -->
            <transition-group name="list" tag="div" class="category-table-wrapper">
                <el-table class="category-table" :data="categoryList" style="width: 100%; margin-bottom: 20px" row-key="id"
                    :show-header="false" :key="'table'">
                    <el-table-column label="分类名称" min-width="200">
                        <template slot-scope="scope">
                            <!-- 编辑状态 -->
                            <div class="edit-form" v-if="scope.row.editing">
                                <el-input v-model="scope.row.tempName" ref="editInput" maxlength="10" show-word-limit
                                    @keyup.enter="saveEdit(scope.row)" size="small" class="edit-input"></el-input>
                                <div class="form-actions">
                                    <div :class="{ disabled: !scope.row.tempName.trim() }" @click="saveEdit(scope.row)">
                                        <img src="@/assets/img/announcement/confirm.png" alt="">
                                    </div>
                                    <div @click="cancelEdit(scope.row)">
                                        <img src="@/assets/img/announcement/cancel.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <span v-else>{{ scope.row.categoryName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <!-- 非编辑状态按钮 -->
                            <template v-if="!scope.row.editing">
                                <div class="action-group">
                                    <!-- 为每个操作按钮添加动画类 -->
                                    <div size="mini" style="cursor:pointer" :disabled="scope.$index === 0" 
                                        @click="moveCategory(scope.row, 'top')" 
                                        :class="{'animating': scope.row.animating === 'top'}">
                                        <img src="@/assets/img/announcement/top.png"
                                            :style="{ opacity: scope.$index === 0 ? 0.3 : 1 }" alt="">
                                    </div>
                                    <div size="mini" style="cursor:pointer" :disabled="scope.$index === categoryList.length - 1"
                                        @click="moveCategory(scope.row, 'up')"
                                        :class="{'animating': scope.row.animating === 'up'}">
                                        <img src="@/assets/img/announcement/up.png"
                                            :style="{ opacity: scope.$index === 0 ? 0.3 : 1 }" alt="">
                                    </div>
                                    <div size="mini" style="cursor:pointer" :disabled="scope.$index === 0"
                                        @click="moveCategory(scope.row, 'down')"
                                        :class="{'animating': scope.row.animating === 'down'}">
                                        <img src="@/assets/img/announcement/down.png"
                                            :style="{ opacity: scope.$index === categoryList.length - 1 ? 0.3 : 1 }" alt="">
                                    </div>
                                    <div size="mini" style="cursor:pointer" :disabled="scope.$index === categoryList.length - 1"
                                        @click="moveCategory(scope.row, 'bottom')"
                                        :class="{'animating': scope.row.animating === 'bottom'}">
                                        <img src="@/assets/img/announcement/bottom.png"
                                            :style="{ opacity: scope.$index === categoryList.length - 1 ? 0.3 : 1 }" alt="">
                                    </div>
                                    <el-dropdown @command="(command) => handleMore(scope.row, command)" trigger="click">
                                        <img src="@/assets/img/announcement/more.png" alt="">
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item class="custom-item" command="edit">重命名</el-dropdown-item>
                                            <el-dropdown-item class="custom-item" command="delete">删除</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </transition-group>
            <div class="add-category">
                <!-- 初始状态显示 -->
                <div v-if="!isAdding" style="cursor:pointer" class="add-trigger" @click="startAdding">
                    <span>新增分类</span>
                    <img src="@/assets/img/announcement/add.png" alt="">
                </div>

                <!-- 添加状态显示 -->
                <div v-else class="add-form">
                    <el-input v-model="newCategoryName" placeholder="请输入分类名称" clearable size="small" ref="addInput"
                        @keyup.enter="confirmAdd" maxlength="10" show-word-limit></el-input>
                    <div class="form-actions">
                        <div class="confirm-btn" @click="confirmAdd" :disabled="!newCategoryName.trim()">
                            <img src="@/assets/img/announcement/confirm.png" alt="">
                        </div>
                        <div class="cancel-btn" @click="cancelAdd">
                            <img src="@/assets/img/announcement/cancel.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 操作提示动画 -->
            <div class="operation-hint" v-if="showOperationHint" :class="hintClass">
                {{ operationHintText }}
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        categories: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dialogVisible: false,
            Loading: false,
            categoryList: [],
            newCategoryName: "",
            nextId: 4,
            isAdding: false,
            showOperationHint: false, // 操作提示显示状态
            operationHintText: "", // 操作提示文本
            hintClass: "" // 提示样式类
        };
    },
    methods: {
        // 显示操作提示
        showHint(type, categoryName) {
            const hints = {
                'top': `已将"${categoryName}"置顶`,
                'up': `已将"${categoryName}"上移`,
                'down': `已将"${categoryName}"下移`,
                'bottom': `已将"${categoryName}"置底`
            };
            
            this.operationHintText = hints[type] || "操作成功";
            this.hintClass = type;
            this.showOperationHint = true;
            
            // 2秒后隐藏提示
            setTimeout(() => {
                this.showOperationHint = false;
            }, 2000);
        },
        
        fetchCategories() {
            this.$api.announcementCList().then(res => {
                if (res.code == 0) {
                    console.log(res, '获取分类');
                    this.categoryList = res.data.map(item => {
                        return {
                            id: item.id,
                            categoryName: item.categoryName,
                            editing: false,
                            tempName: "",
                            animating: "" // 添加动画状态
                        }
                    })
                }
            })
        },
        startAdding() {
            this.isAdding = true;
            this.newCategoryName = "";
            this.$nextTick(() => {
                this.$refs.addInput.focus();
            });
        },
        confirmAdd() {
            if (!this.newCategoryName.trim()) {
                this.$message.warning("分类名称不能为空");
                return;
            }
            this.$api.announcementCAdd({
                categoryName: this.newCategoryName.trim(),
                sortType: 'bottom'
            }).then(res => {
                if (res.code == 0) {
                    console.log(res, '添加分类');
                    this.fetchCategories();
                }
            });
            //重置状态
            this.cancelAdd();
        },
        // 取消添加
        cancelAdd() {
            this.isAdding = false;
            this.newCategoryName = "";
        },
        openDialog(refresh = false) {
            this.dialogVisible = true;
            // 关闭所有编辑状态
            this.resetEditing();

            // 如果需要刷新或者当前没有分类数据，则获取分类列表
            if (refresh || this.categoryList.length === 0) {
                this.fetchCategories();
            }
        },

        // 添加新分类
        addCategory() {
            if (!this.newCategoryName.trim()) {
                this.$message.warning("分类名称不能为空");
                return;
            }

            this.categoryList.push({
                id: this.nextId++,
                name: this.newCategoryName.trim(),
                editing: false,
                tempName: "",
                animating: ""
            });
            this.newCategoryName = "";
            this.$message.success("分类添加成功");
        },

        // 开始编辑
        startEdit(category) {
            // 关闭所有其他编辑状态
            this.resetEditing();

            category.editing = true;
            category.tempName = category.categoryName;

            // 使用$nextTick确保DOM更新后聚焦输入框
            this.$nextTick(() => {
                if (this.$refs.editInput) {
                    this.$refs.editInput.focus();
                }
            });
        },

        // 保存编辑
        saveEdit(category) {
            if (!category.tempName.trim()) {
                this.$message.warning("分类名称不能为空");
                return;
            }
            this.$api.announcementCUpdate({
                categoryId: category.id,
                categoryName: category.tempName.trim(),
            }).then(res => {
                if (res.code == 0) {
                    category.categoryName = category.tempName.trim();
                    category.editing = false;
                    this.$message.success("分类名称修改成功");
                } else {
                    this.$message.error(res.msg || "分类名称修改失败");
                }
            }).catch(() => {
                this.$message.error("分类名称修改失败");
            });

        },

        // 取消编辑
        cancelEdit(category) {
            category.editing = false;
            category.tempName = "";
        },

        // 重置所有编辑状态
        resetEditing() {
            this.categoryList.forEach(item => {
                if (item.editing) {
                    item.editing = false;
                    item.tempName = "";
                }
            });
        },

        // 删除分类 - 修改后的方法
        handleDelete(category) {
            // 找到category在列表中的索引
            const index = this.categoryList.findIndex(item => item.id === category.id);
            if (index === -1) return;
            this.$api.announcementCDelete({
                id: category.id
            }).then(res => {
                if (res.code == 0) {
                    console.log(category, '删除分类');
                    this.categoryList.splice(index, 1);
                    this.$message.success("分类删除成功");
                    this.fetchCategories();
                    // this.loading = false;
                } else {
                    this.$message.error(res.msg || "分类删除失败");
                    // this.loading = false;
                }
            }).catch(error => {
                console.error("删除分类出错:", error);
                this.$message.error("分类删除失败");
            });
        },

        // 移动分类
        moveCategory(category, direction) {
            const index = this.categoryList.findIndex(item => item.id === category.id);

            //检查是否可移动
            if ((direction === 'up' || direction === 'top') && index === 0) return;
            if ((direction === 'down' || direction === 'bottom') && index === this.categoryList.length - 1) return;
            if (category.updating) return;

            // 设置动画状态
            category.animating = direction;
            
            //设置更新状态
            category.updating = true;

            this.updateSort(category.id, direction, index);
        },

        //更新排序API调用
        updateSort(id, sortType, currentIndex) {
            this.$api.announcementCUpdateSort({
                categoryId: id,
                sortType: sortType,
                categoryName: this.categoryList[currentIndex].categoryName,
            }).then(res => {
                if (res.code == 0) {
                    // 显示操作提示
                    this.showHint(sortType, this.categoryList[currentIndex].categoryName);
                    this.applySortChange(id, sortType, currentIndex);
                } else {
                    this.$message.error(res.msg || "分类排序更新失败");
                    this.categoryList.find(item => item.id === id).updating = false;
                    this.categoryList.find(item => item.id === id).animating = "";
                }
            }).catch(() => {
                this.$message.error("排序更新失败");
                this.categoryList.find(item => item.id === id).updating = false;
                this.categoryList.find(item => item.id === id).animating = "";
            });
        },

        // 应用排序变更到UI
        applySortChange(id, sortType, currentIndex) {
            const item = this.categoryList[currentIndex];
            const newList = [...this.categoryList];

            switch (sortType) {
                case "up":
                    newList.splice(currentIndex, 1);
                    newList.splice(currentIndex - 1, 0, item);
                    break;
                case "down":
                    newList.splice(currentIndex, 1);
                    newList.splice(currentIndex + 1, 0, item);
                    break;
                case "top":
                    newList.splice(currentIndex, 1);
                    newList.unshift(item);
                    break;
                case "bottom":
                    newList.splice(currentIndex, 1);
                    newList.push(item);
                    break;
            }

            this.categoryList = newList;

            // 重置更新状态和动画状态
            setTimeout(() => {
                item.updating = false;
                item.animating = "";
            }, 300); // 与CSS动画时间保持一致
        },

        handleMore(category, command) {
            console.log(category, command);

            if (command === 'edit') {
                this.startEdit(category);
            } else if (command === 'delete') {
                this.handleDelete(category);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.category-dialog {
    display: flex;
    flex-direction: column;

    /deep/ .el-dialog {
        width: 552px;
        max-height: 80vh;
        margin: 0 auto !important;
        top: 50% !important;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        position: relative;
    }

    /deep/ .el-dialog__body {
        padding: 0 0 16px 0;
        flex: 1 1 auto;
        overflow: auto;
    }
}

// 添加列表过渡动画
.category-table-wrapper {
  position: relative;
}

.list-move {
  transition: transform 0.3s ease;
}

// 操作按钮动画
.action-group {
    div.animating {
        position: relative;
        overflow: visible;
        
        &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            width: 20px;
            height: 20px;
            margin: -15px 0 0 -6px;
            border: 2px solid #00B498;
            border-radius: 50%;
            border-top-color: transparent;
            animation: spin 0.6s linear infinite;
        }
        
        img {
            opacity: 0.5;
        }
    }
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

// 操作提示动画
.operation-hint {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 8px 16px;
    border-radius: 4px;
    background-color: #f0f9eb;
    color: #67c23a;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    animation: fadeInUp 0.5s ease;
    
    &.top { background-color: #f0f9eb; color: #67c23a; }
    &.up { background-color: #f0f9eb; color: #67c23a; }
    &.down { background-color: #f0f9eb; color: #67c23a; }
    &.bottom { background-color: #f0f9eb; color: #67c23a; }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translate(-50%, 20px);
    }
    to {
        opacity: 1;
        transform: translate(-50%, 0);
    }
}

.category-table {
    /deep/ {
        .el-table__cell {
            text-align: left;
            padding: 15px 10px 13px 20px;
            font-weight: 400;
            font-size: 15px;
            color: #2F3030;
            overflow: visible;

            div {
                overflow: visible;
            }
        }

        .el-table__cell:last-child {
            text-align: right;
            padding: 15px 20px 13px 10px;
        }
    }
}

.edit-form {
    width: 300px;
    display: flex;
    margin-left: -15px;

    /deep/ {
        .el-input {
            width: 220px;
            margin-right: 14px;
        }

        .el-input--small .el-input__inner {
            height: 37px;
            line-height: 37px;
        }
    }

    .form-actions {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 28px;
            height: 28px;
            margin-right: 10px;
        }
    }
}

.action-group {
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;

    /deep/ {
        .el-button {
            border: none;
        }
    }

    img {
        width: 28px;
        height: 28px;
        margin-left: 10px;
        transition: opacity 0.3s;
    }
}

/* 添加一些过渡效果 */
.el-table__row {
    transition: all 0.3s ease;
}

.el-table__row:hover {
    background-color: #f5f7fa;
    transform: translateY(-2px);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.add-category {
    .add-trigger {
        width: 220px;
        margin-left: 30px;
        font-weight: 400;
        font-size: 15px;
        color: #2F3030;
        margin-right: 8px;
        :hover {
            color: #00B498;
        }
        img {
            margin-left: 8px;
            width: 12px;
            height: 12px;
        }
    }

    .add-form {
        display: flex;
        margin-left: 8px;

        /deep/ {
            .el-input {
                width: 220px;
                margin-right: 14px;
            }

            .el-input--small .el-input__inner {
                height: 37px;
                line-height: 37px;
            }
        }

        .form-actions {
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 28px;
                height: 28px;
                margin-right: 10px;
            }
        }
    }
}
</style>
